module.exports = __webpack_public_path__ + "assets/fb3c8e2c4d72d9873343972474f3df03.png";